import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import SchoolSwitcher from "./components/SchoolSwitcher";
import ScrollToTop from "./components/ScrollToTop";
import SchoolLeavingCertificate from "./pages/certificates/SchoolLeavingCertificate";
import CharacterCertificate from "./pages/certificates/CharacterCertificate";
import BonafideCertificate from "./pages/certificates/BonafideCertificate";
import PageTitle from "./pages/schools/PageTitle";
import Login from "./pages/schools/Login";
import Signup from "./pages/schools/SchoolSignup";
import Dashboard from "./pages/schools/Dashboard";
import AddStudent from "./pages/schools/AddStudent";
import ViewStudent from "./pages/schools/ViewStudent";
import StudentDetails from "./pages/schools/StudentDetails";
import StudentBill from "./pages/schools/StudentBill";
import AllStudentBill from "./pages/schools/AllStudentBill";
import StaffWallet from "./pages/schools/StaffWallet";
import StaffSalary from "./pages/schools/StaffSalary";
import AdminWallet from "./pages/schools/AdminWallet";
import WalletHistory from "./pages/schools/WalletHistory";
import Notice from "./pages/schools/Notice";
import ProductCategory from "./pages/schools/ProductCategory";
import ProductSubcategory from "./pages/schools/ProductSubcategory";
import Product from "./pages/schools/Product";
import ProductVariant from "./pages/schools/ProductVariant";
import ProductStock from "./pages/schools/ProductStock";
import ProductBundleCreate from "./pages/schools/ProductBundleCreate";
import ProductBundleList from "./pages/schools/ProductBundleList";
import VendorStockReport from "./pages/schools/VendorStockReport";
import ProductBundleView from "./pages/schools/ProductBundleView";
import SubjectPage from "./pages/schools/SubjectPage";
import ClassSubjectAssignPage from "./pages/schools/ClassSubjectAssignPage";
import TeacherManagementPage from "./pages/schools/TeacherManagementPage";
import TeacherSubjectAssignPage from "./pages/schools/TeacherSubjectAssignPage";
import DepartmentPage from "./pages/schools/DepartmentPage";
import FeesStructureListPage from "./pages/schools/FeesStructureListPage";
import FeesStructureOthersListPage from "./pages/schools/FeesStructureOthersListPage";

// Student Product Billing
import ProductBilling from "./pages/schools/ProductBilling";
// Student Product Billing History
import ProductBillingHistory from "./pages/schools/ProductBillingHistory";
// Super Admin (Platform) imports
import SuperAdminLogin from "./pages/super_admin/Login";
import SuperAdminDashboard from "./pages/super_admin/Dashboard";
import SuperAdminLayout from "./components/super_admin/Layout";
import Schools from "./pages/super_admin/Schools";
import SchoolProfile from "./pages/super_admin/SchoolProfile";
import Subscriptions from "./pages/super_admin/Subscriptions";
import SubscriptionDetails from "./pages/super_admin/SubscriptionDetails";
import Admins from "./pages/super_admin/Admins";
import SchoolAdmins from "./pages/super_admin/SchoolAdmins";
import SchoolAdminDetails from "./pages/super_admin/SchoolAdminDetails";
import AccountsExpense from "./pages/finance/AccountsExpense";
import RevenueOverview from "./pages/super_admin/RevenueOverview";
import SchoolRevenueDetails from "./pages/super_admin/SchoolRevenueDetails";
// Monthly Due Report
// Monthly Due Report
import MonthlyDueReportPage from "./pages/reports/MonthlyDueReportPage";
import MonthlyDueClassPage from "./pages/reports/MonthlyDueClassPage";
import MonthlyDueStudentPage from "./pages/reports/MonthlyDueStudentPage";

import ProfitLossReportPage from "./pages/reports/ProfitLossReportPage";
import ProfitLossMonthPage from "./pages/reports/ProfitLossMonthPage";
import ProfitLossFeeDetailsPage from "./pages/reports/ProfitLossFeeDetailsPage";
// import new Admission Page
import PreAdmissionForm from "./pages/pre_admission/PreAdmissionForm";
import ApplicantView from "./pages/schools/ApplicantView";

// add class & serction
import ClassSectionPage from "./pages/schools/ClassSectionPage";
import ClassTeacherPage from "./pages/schools/ClassTeacherPage";


// application exam , assign & list
import ExamManagement from "./pages/exam/ExamManagement";
import ExamResultManagement from "./pages/exam/ExamResultManagement";
import ParentInterviewManagement from "./pages/exam/ParentInterviewManagement";
import PreAdmissionLogin from "./pages/pre_admission/PreAdmissionLogin";
import PreAdmissionDashboard from "./pages/pre_admission/PreAdmissionDashboard";

// expense catetory & sub category
import ExpenseCategoryPage from "./pages/expense/ExpenseCategoryPage";
import ExpenseSubCategoryPage from "./pages/expense/ExpenseSubCategoryPage";
import ExpensePage from "./pages/expense/ExpensePage";
import ExpenseReportPage from "./pages/expense/ExpenseReportPage";
import FinancialReport from "./pages/reports/FinancialReport";
import SalaryReportPage from "./pages/reports/SalaryReportPage";
// expense vendor add/update, list & delete
import VendorPage from "./pages/vendor/VendorPage";

// Student Promotion 
import StudentPromotionPage from "./pages/schools/StudentPromotionPage";

// School Academic Management
import AcademicSessionPage from "./pages/schools/AcademicSessionPage";

// Exam Management
import ExamManagementPage from "./pages/school_exams/ExamManagementPage";
import ExamSubjectAssignPage from "./pages/school_exams/ExamSubjectAssignPage";

// Mark roll entry
import MarkRollEntryPage from "./pages/school_exams/MarkRollEntryPage";

// Student Mark Sheet list
import StudentMarksheetListPage from "./pages/school_exams/StudentMarksheetListPage";
// Grade Rule Page
import GradeRulesPage from "./pages/school_exams/GradeRulesPage";
// Permission master Page
import PermissionMasterPage from "./pages/schools/PermissionMasterPage";
// Teacher Permission master Page
import TeacherPermissionPage from "./pages/schools/TeacherPermissionPage";
// Marks type Page
import MarkTypesPage from "./pages/school_exams/MarkTypesPage";
// Template Designer Page
import TemplateDesignerPage from "./pages/school_exams/template_builder/TemplateDesignerPage";
// Student ID Card Page
import StudentIdCard from "./pages/schools/StudentIdCardPage";
// Teacher ID Card Page
import TeacherIdCard from "./pages/schools/TeacherIdCardPage";
// Class Section Working Days Page
import ClassSectionWorkingDays from "./pages/schools/ClassSectionWorkingDays";

// Attendance
import StudentAttendancePage from "./pages/schools/StudentAttendanceList";
import TeacherAttendancePage from "./pages/schools/TeacherAttendancePage";
// Valid Student Page
import ValidStudent from "./pages/ValidStudent";
// Valid Teacher Page
import ValidTeacher from "./pages/ValidTeacher";

import StudentAttendanceReportPage from "./pages/reports/StudentAttendanceReportPage";
/************** Salary System *************************/

// Salary Structure
import SalaryStructurePage from "./pages/salary/SalaryStructurePage";
// Salary Payroll
import SalaryPayrollPage from "./pages/salary/SalaryPayrollPage";

// student unpaid fees
import UnpaidStudentsPage from "./pages/schools/UnpaidStudentsPage";
import AdmitCardPage from "./pages/school_exams/AdmitCardPage";
import AdmitListPage from "./pages/school_exams/AdmitListPage";
import LibraryBooksPage from "./pages/library/LibraryBooksPage";
import LibraryAssignBooksPage from "./pages/library/LibraryAssignBooksPage";
import "./App.css";
import "./index.css";
function ExternalRedirect({ url }) {
  React.useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <PageTitle />
      <Routes>
        {/* -------------------- Public routes -------------------- */}
        <Route
          path="/"
          element={<Navigate to="/login" replace />}
        />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/super_admin/login" element={<SuperAdminLogin />} />
        {/* valid student page */}
        <Route path="/valid_student/:token" element={<ValidStudent />} />
        {/* valid teacher page */}
        <Route path="/valid_teacher/:token" element={<ValidTeacher />} />

        {/* ✅ New Multi-School Admission Route */}
        <Route path="/pre-admission" element={<PreAdmissionForm />} />
        <Route path="/pre-admission/student_login" element={<PreAdmissionLogin />} />
        <Route path="/pre-admission/dashboard" element={<PreAdmissionDashboard />} />

        {/* -------------------- School Panel -------------------- */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireUserType="school">
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route
            index
            element={
              <>
                <div style={{ display: "flex", justifyContent: "flex-end", padding: 8 }}>
                  <SchoolSwitcher />
                </div>
                <Dashboard />
              </>
            }
          />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="add-student" element={<AddStudent />} />
          <Route path="edit-student/:id" element={<AddStudent />} />
          <Route path="view-student" element={<ViewStudent />} />
          <Route path="view-student-details/:encodedId" element={<StudentDetails />} />
          <Route path="student-billing" element={<StudentBill />} />
          <Route path="all-billing" element={<AllStudentBill />} />
          <Route path="staff/wallet" element={<StaffWallet />} />
          <Route path="staff/salary" element={<StaffSalary />} />
          <Route path="wallet" element={<AdminWallet />} />
          <Route path="wallet-history" element={<WalletHistory />} />
          <Route path="notice" element={<Notice />} />
          <Route path="product-category" element={<ProductCategory />} />
          <Route path="product-sub-category" element={<ProductSubcategory />} />
          <Route path="product-bundle/create" element={<ProductBundleCreate />} />
          <Route path="product-bundle/list" element={<ProductBundleList />} />
          <Route path="product-vendor/list" element={<VendorStockReport />} />
          <Route path="product-bundle/view/:id" element={<ProductBundleView />} />
          <Route path="student/product-billing" element={<ProductBilling />} />
          <Route path="student/product-billing/history" element={<ProductBillingHistory />} />
          <Route path="subject-add" element={<SubjectPage />} />
          <Route path="subject-class/assign" element={<ClassSubjectAssignPage />} />
          <Route path="teacher-add" element={<TeacherManagementPage />} />
          <Route path="teacher-subject/assign" element={<TeacherSubjectAssignPage />} />
          <Route path="department-add" element={<DepartmentPage />} />
          <Route path="applicant/view" element={<ApplicantView />} />
          <Route path="application/exam" element={<ExamManagement />} />
          <Route path="application/exam/publish_result" element={<ExamResultManagement />} />
          <Route path="application/parent/interview" element={<ParentInterviewManagement />} />
          <Route path="fees_structure/list" element={<FeesStructureListPage />} />
          <Route path="fees_structure/others" element={<FeesStructureOthersListPage />} />
          <Route path="class-section/manage" element={<ClassSectionPage />} />
          <Route path="class-section/working-days" element={<ClassSectionWorkingDays />} />
          

          <Route
            path="class-teacher/assign"
            element={<ClassTeacherPage />}
          />
          {/* Attendance */}

          <Route
            path="attendance/student"
            element={<StudentAttendancePage />}
          />

          <Route
            path="attendance/teacher"
            element={<TeacherAttendancePage />}
          />

        <Route
            path="reports/student-attendance"
            element={<StudentAttendanceReportPage />}
          />


          {/* Expense Category & sub category route */}
          <Route path="expense/category" element={<ExpenseCategoryPage />} />
          <Route path="expense/sub-category" element={<ExpenseSubCategoryPage />} />
          <Route path="expense/add" element={<ExpensePage />} />
          <Route path="expense-report" element={<ExpenseReportPage />} />

          {/* Expense vendor route */}
          <Route path="vendor/list" element={<VendorPage />} />

          {/* student promotion */}
          <Route path="student/promotion" element={<StudentPromotionPage />} />
          {/* school academic management */}
          <Route path="school/academic-years" element={<AcademicSessionPage />} />
          {/* school exam management */}
          <Route path="exam-management/add" element={<ExamManagementPage />} />


          {/* 
         school admit
          <Route path="exam-management/add" element={<ExamManagementPage/>} /> */}
          {/* school exam subject assign management */}

          {/* Library */}
          <Route path="library/books" element={<LibraryBooksPage />} />
          <Route path="library/assign-books" element={<LibraryAssignBooksPage />} />


          {/* school exam subject assign management */}
          {/* admit */}
          <Route path="/admin/admit-card/entry" element={<AdmitCardPage />} />
          <Route path="admit-card/list" element={<AdmitListPage />} />
          <Route path="exam-subject-management/add" element={<ExamSubjectAssignPage />} />
          {/* school exam mark roll management */}
          <Route path="mark-roll/entry" element={<MarkRollEntryPage />} />
          {/* Student Mark Sheet */}
          <Route path="mark-sheet/list" element={<StudentMarksheetListPage />} />
          {/* Grade Rules */}
          <Route path="grade-rules/list" element={<GradeRulesPage />} />
          {/* Permissions Master */}
          <Route path="permission-master/list" element={<PermissionMasterPage />} />
          {/* Teacher Permissions */}
          <Route path="teacher-permission/list" element={<TeacherPermissionPage />} />
          {/* Marks type */}
          <Route path="mark-types/list" element={<MarkTypesPage />} />
          {/* Template Designer */}
          <Route path="exam/templates/builder" element={<TemplateDesignerPage />} />
          {/* student id card */}
          <Route path="student/id-card" element={<StudentIdCard />} />
          {/* teacher id card */}
          <Route path="teacher/id-card" element={<TeacherIdCard />} />
          <Route
            path="certificate/school-leaving"
            element={<SchoolLeavingCertificate />}
          />

          <Route
            path="certificate/character"
            element={<CharacterCertificate />}
          />

          <Route
            path="certificate/bonafide"
            element={<BonafideCertificate />}
          />
          {/* salary structure */}
          <Route path="salary-structure" element={<SalaryStructurePage />} />
          {/* salary structure */}
          <Route path="salary-payroll" element={<SalaryPayrollPage />} />
          <Route path="reports/salary" element={<SalaryReportPage />} />
          {/* unpaid fee report */}
          <Route path="unpaid-students" element={<UnpaidStudentsPage />} />
          {/* ============================================================
    MONTHLY DUE REPORT
============================================================ */}

          <Route
            path="reports/monthly-due"
            element={<MonthlyDueReportPage />}
          />

          <Route
            path="reports/monthly-due/:month"
            element={<MonthlyDueClassPage />}
          />

          <Route
            path="reports/monthly-due/:month/class/:classId"
            element={<MonthlyDueStudentPage />}
          />


          {/* ============================================================
    PROFIT & LOSS REPORT
============================================================ */}

          <Route
            path="reports/profit-loss"
            element={<ProfitLossReportPage />}
          />

          <Route
            path="reports/profit-loss/:month"
            element={<ProfitLossMonthPage />}
          />
          <Route
            path="reports/profit-loss/:month/fee/:feeType"
            element={<ProfitLossFeeDetailsPage />}
          />
          <Route
            path="reports/financial-report"
            element={<FinancialReport />}
          />

          {/* ============================================================
    ADMIN FALLBACK
    MUST BE LAST
============================================================ */}

          <Route
            path="*"
            element={
              <Navigate
                to="dashboard"
                replace
              />
            }
          />

        </Route>

        {/* -------------------- Platform Super Admin Panel -------------------- */}
        <Route
          path="/super_admin"
          element={
            <ProtectedRoute requireUserType="platform">
              <SuperAdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<SuperAdminDashboard />} />
          <Route path="dashboard" element={<SuperAdminDashboard />} />
          <Route path="schools" element={<Schools />} />
          <Route path="schools/:schoolId" element={<SchoolProfile />} />
          <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="subscriptions/:schoolId" element={<SubscriptionDetails />} />
          <Route path="revenue" element={<RevenueOverview />} />
          <Route path="revenue/:schoolId" element={<SchoolRevenueDetails />} />
          <Route path="schooladmins" element={<SchoolAdmins />} />
          <Route path="schooladmins/:schoolId" element={<SchoolAdminDetails />} />
          <Route
            path="accounts-expense"
            element={<AccountsExpense />}
          />

          {/* fallback */}
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Route>

        {/* -------------------- Fallback -------------------- */}
        <Route
          path="*"
          element={<Navigate to="/login" replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;
